import { Router } from 'next/router'
import { Footer } from './Footer'

interface Props {
  children: JSX.Element
  router: Router
}

export function Layout({ children, router }: Props) {
  const isNotDashboard = router.pathname.indexOf('/dashboard') !== 0
  return (
    <div>
      <div
        className={
          'min-h-screen pb-12 sm:pb-36' + (isNotDashboard ? ' bg-gray-50' : '')
        }
      >
        {children}
      </div>
      <Footer />
    </div>
  )
}
